import { DescriptionPage_UpsellType as UpsellType } from '__generated__/graphql-types';

import { getUpsellCopy } from 'bundles/stackability-common';
import type { DegreeFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';

const getEligibleDegreesTitle = (degrees: Array<DegreeFragment>) => {
  // Use the first upsell when there are multiple
  const upsellType = degrees[0]?.upsellType;

  const copy = getUpsellCopy().homepagesNavXdp;

  if (!upsellType || upsellType === UpsellType.RelatedTo) {
    return copy.prepareForADegree;
  } else {
    return copy.buildTowardADegree;
  }
};

export default getEligibleDegreesTitle;
